import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isError: false,
  message: "",
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setError: (state, action) => {
      state.isError = true;
      state.message = action.payload;
    },
    clearError: (state) => {
      state.isError = false;
      state.message = "";
    },
  },
});

export const { setError, clearError } = errorSlice.actions;
export const selectIsError = (state) => state.error.isError;

export default errorSlice.reducer;
